import React from 'react';
import { NavLink } from 'react-router-dom';

const TimesheetsCrumb = () => <NavLink to="/human-resources/timesheets">Timesheets</NavLink>;

export default TimesheetsCrumb;
